import React from 'react';
import PropTypes from 'prop-types';
import { CapabilitiesDisclaimer } from '../../atoms/capabilitiesDisclaimer';
import { themeStyles } from '../../../styles/theme';

const DepositBlockedMessage = ({ blockedDepositReason, onClose }) => {
  if (
    blockedDepositReason !== 'NATIONAL_ID_INVALID' &&
    blockedDepositReason !== 'NATIONAL_ID_PROCESSING'
  ) {
    return (
      <CapabilitiesDisclaimer
        color={themeStyles.colors.black.main}
        onClose={onClose}
      />
    );
  }
  return null;
};

DepositBlockedMessage.propTypes = {
  blockedDepositReason: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export { DepositBlockedMessage };